module.exports = __webpack_public_path__ + "img/delete.93f28099.svg";